module.exports = __webpack_public_path__ + "img/07.e13b0efb.jpg";